import { render, staticRenderFns } from "./MeetingSetting.vue?vue&type=template&id=450bb0c4&scoped=true&"
import script from "./MeetingSetting.vue?vue&type=script&lang=js&"
export * from "./MeetingSetting.vue?vue&type=script&lang=js&"
import style0 from "./MeetingSetting.vue?vue&type=style&index=0&id=450bb0c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450bb0c4",
  null
  
)

export default component.exports